import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { DialogDescription } from "@/components/ui/dialog";
import { useTranslations } from "@/hooks/use-translations";

export function VisuallyHiddenDialogDescription() {
  const { __ } = useTranslations();

  return (
    <VisuallyHidden>
      <DialogDescription>
        {__("bank_id.identify_with_bank_id")}
      </DialogDescription>
    </VisuallyHidden>
  );
}
